import { h, Component } from "preact";
import config from "../../../config";
import LocationAutocomplete from "location-autocomplete";

import GoogleServices from "../../../services/GoogleServices";

class LocationSearch extends Component {
  constructor(props) {
    super(props);
    this.getLatLng = this.getLatLng.bind(this);
  }

  getLatLng(value) {
    const { updateLocation } = this.props;
    GoogleServices.getGeocode(value).then(res => {
      updateLocation(
        value,
        res.data.results[0].geometry.location.lat,
        res.data.results[0].geometry.location.lng
      );
    });
  }

  render() {
    const { style, placeholder } = this.props;
    return (
      <LocationAutocomplete
        className={style}
        googleAPIKey={config("GOOGLE_API_KEY")}
        onChange={val => {
          this.getLatLng(val.target.value);
        }}
        onDropdownSelect={val => {
          this.getLatLng(val.input.value);
        }}
        placeholder={placeholder}
        aria-label="Location search"
      />
    );
  }
}

export default LocationSearch;
